import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between px-s3" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-muted" }

import Caption from '@/components/Caption.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import { useEasyModeForm } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';
import { toDecimalPlacesOrLT } from '@/utils/format';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'LossInfo',
  setup(__props) {

const { easyModeForm, lossIsLoading, lossIsHuge, lossIsSmall, lossUSD } = useEasyModeForm();
const { t } = useI18n();

const feeCallReverted = computed(() => easyModeForm.impactError);

const percentClass = computed(() => {
  if (easyModeForm.lossPercent === undefined || feeCallReverted) {
    return '';
  }

  if (lossIsHuge.value || lossIsSmall.value) {
    return 'text-warning';
  }

  return 'text-success';
});

const percent = computed(() => toDecimalPlacesOrLT(easyModeForm.lossPercent));
const usdSymbolAndAmount = computed(() =>
  toDecimalPlacesOrLT(lossUSD.value, { addUsdSymbol: true }),
);

const caption = t(`portfolio.loss.caption`);
const tooltip = t(`portfolio.loss.tooltip`);

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Caption, {
      caption: _unref(caption),
      tooltip: _unref(tooltip)
    }, null, 8, ["caption", "tooltip"]),
    (_unref(lossIsLoading))
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          class: "w-7rem"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(feeCallReverted))
            ? (_openBlock(), _createBlock(InfoMessage, {
                key: 0,
                class: "align-items-center",
                type: "danger",
                message: _unref(t)('tooBig'),
                size: "16"
              }, null, 8, ["message"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_unref(percentClass))
                }, _toDisplayString(_unref(usdSymbolAndAmount) || '$0'), 3),
                _createElementVNode("span", _hoisted_3, " (" + _toDisplayString(_unref(percent) || '0') + "%)", 1)
              ], 64))
        ]))
  ]))
}
}

})